module.exports = __webpack_public_path__ + "img/dashboard.9e655fed.png";